export default __webpack_public_path__ + "static/media/48.5b699ee7.png";